import * as tslib_1 from "tslib";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { of } from 'rxjs/observable/of';
import { CalendarFetcher } from '../CalendarFetcher/CalendarFetcher';
import { Translator } from '../Translate/Translator';
/** @internal */
var currDate = new Date();
currDate.setUTCHours(0, 0, 0, 0);
/** The main calendar component */
var GhContribCalendarComponent = (function () {
    function GhContribCalendarComponent(cdr, fetcher, tr) {
        /** @internal */
        this._numLoading = 0;
        /** Any errors that occurred */
        this.error = new EventEmitter();
        /** Whether or not the controls for changing the year should be shown */
        this.showControls = true;
        /** @internal */
        this.user$ = new BehaviorSubject(null);
        /** @internal */
        this.d$ = new BehaviorSubject(currDate.getUTCDate());
        /** @internal */
        this.formatterFn$ = new BehaviorSubject(null);
        /** @internal */
        this.m$ = new BehaviorSubject((currDate.getUTCMonth() + 1));
        /** @internal */
        this.y$ = new BehaviorSubject(currDate.getUTCFullYear());
        this.tr = tr;
        this.fetcher = fetcher;
        this.cdr = cdr;
    }
    Object.defineProperty(GhContribCalendarComponent.prototype, "atMaxRange", {
        /** Whether or not the entered date is today */
        get: function () {
            return currDate.getTime() === this.toDate.getTime();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "day", {
        /** The entered day getter */
        get: function () {
            return this.d$.value;
        },
        /** The entered day setter */
        set: function (v) {
            this.d$.next(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "formatterFn", {
        /** Proxy formatter function getter */
        get: function () {
            return this.formatterFn$.value;
        },
        /** Proxy formatter function setter */
        set: function (fn) {
            if (!fn || typeof fn === 'function') {
                this.formatterFn$.next(fn);
            }
            else {
                throw new Error('formatter-fn must be falsy or a function');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "locale", {
        /** Locale setter */
        set: function (val) {
            this.tr.setLocale(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "month", {
        /** Entered month getter */
        get: function () {
            return this.m$.value;
        },
        /** Entered month setter */
        set: function (v) {
            this.m$.next(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "to", {
        /** Entered date setter */
        set: function (v) {
            if (typeof v === 'string' && /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/.test(v)) {
                var spl = v.split('-');
                this.year = spl[0];
                this.month = spl[1]; // tslint:disable-line:no-magic-numbers
                this.day = spl[2]; // tslint:disable-line:no-magic-numbers
            }
            else if (v instanceof Date) {
                this.year = v.getUTCFullYear();
                this.month = (v.getUTCMonth() + 1);
                this.day = v.getUTCDate();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "translations", {
        /** Custom translations setter */
        set: function (val) {
            this.tr.registerTranslations(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "user", {
        /** Entered user getter */
        get: function () {
            return this.user$.value;
        },
        /** Entered user setter */
        set: function (user) {
            if (this.user && user !== this.user) {
                this.to = currDate;
            }
            this.user$.next(user);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "year", {
        /** Entered year getter */
        get: function () {
            return this.y$.value;
        },
        /** Entered year setter */
        set: function (v) {
            this.y$.next(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "numLoading", {
        /** @internal */
        get: function () {
            return this._numLoading;
        },
        /** @internal */
        set: function (num) {
            this._numLoading = num;
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GhContribCalendarComponent.prototype, "toDate", {
        /** @internal */
        get: function () {
            var d = new Date();
            d.setUTCHours(0, 0, 0, 0);
            d.setUTCFullYear(parseInt(this.year, 10 /* STD_RADIX */), parseInt(this.month, 10 /* STD_RADIX */) - 1, parseInt(this.day, 10 /* STD_RADIX */));
            return d;
        },
        enumerable: true,
        configurable: true
    });
    GhContribCalendarComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = [this.user$, this.y$, this.m$, this.d$, this.formatterFn$]; _i < _a.length; _i++) {
            var s = _a[_i];
            s.complete();
            s.unsubscribe();
        }
    };
    /** @internal */
    GhContribCalendarComponent.prototype.ngOnInit = function () {
        this.setupData();
    };
    /** @internal */
    GhContribCalendarComponent.prototype.transformAtIndex = function (index) {
        return "translate(" + index * 13 /* OUTER_G_TRANSFORM_MULTIPLIER */ + ",0)";
    };
    /** @internal */
    GhContribCalendarComponent.prototype.updateRange = function (dir) {
        if (dir === -1) {
            this.y$.next(parseInt(this.year, 10 /* STD_RADIX */) - 1);
        }
        else {
            var td = this.toDate;
            td.setUTCFullYear(td.getUTCFullYear() + 1);
            this.to = td > currDate ? currDate : td;
        }
    };
    GhContribCalendarComponent.prototype.setupData = function () {
        var _this = this;
        var decrease = function () {
            _this.numLoading--;
        };
        var data = combineLatest(this.user$.distinctUntilChanged(), this.y$.distinctUntilChanged(), this.m$.map(formatAndPad).distinctUntilChanged(), this.d$.map(formatAndPad).distinctUntilChanged(), this.formatterFn$)
            .filter(function (v) { return !!v[0]; })
            .debounceTime(250 /* FETCH_DEBOUNCE_TIME */)
            .switchMap(function (v) {
            _this.numLoading++;
            // tslint:disable-next-line:no-magic-numbers
            var r = _this.fetcher.fetch(v[0], v[1], v[2], v[3], v[4]).share();
            r.toPromise().then(decrease).catch(decrease);
            return r;
        })
            .catch(function (e) {
            _this.error.emit(e);
            _this.user$.next(null);
            setTimeout(function () {
                _this.setupData();
            }, 0);
            return of(null);
        });
        this.data = data.filter(function (v) { return !!v; }).share();
    };
    tslib_1.__decorate([
        Output('error'),
        tslib_1.__metadata("design:type", Object)
    ], GhContribCalendarComponent.prototype, "error", void 0);
    tslib_1.__decorate([
        Input('show-controls'),
        tslib_1.__metadata("design:type", Object)
    ], GhContribCalendarComponent.prototype, "showControls", void 0);
    tslib_1.__decorate([
        Input('d'),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "day", null);
    tslib_1.__decorate([
        Input('formatter-fn'),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Function])
    ], GhContribCalendarComponent.prototype, "formatterFn", null);
    tslib_1.__decorate([
        Input('locale'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [String])
    ], GhContribCalendarComponent.prototype, "locale", null);
    tslib_1.__decorate([
        Input('m'),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "month", null);
    tslib_1.__decorate([
        Input('to'),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "to", null);
    tslib_1.__decorate([
        Input('translations'),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "translations", null);
    tslib_1.__decorate([
        Input('user'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [String])
    ], GhContribCalendarComponent.prototype, "user", null);
    tslib_1.__decorate([
        Input('y'),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], GhContribCalendarComponent.prototype, "year", null);
    GhContribCalendarComponent = tslib_1.__decorate([
        Component({
            changeDetection: ChangeDetectionStrategy.OnPush,
            providers: [Translator, CalendarFetcher],
            selector: 'gh-contrib-calendar',
            styles: [require('./GhContribCalendarComponent.scss')],
            template: require('./GhContribCalendarComponent.pug')
        }),
        tslib_1.__param(0, Inject(ChangeDetectorRef)),
        tslib_1.__param(1, Inject(CalendarFetcher)),
        tslib_1.__param(2, Inject(Translator)),
        tslib_1.__metadata("design:paramtypes", [Object, CalendarFetcher,
            Translator])
    ], GhContribCalendarComponent);
    return GhContribCalendarComponent;
}());
export { GhContribCalendarComponent };
/** @internal */
function formatAndPad(v) {
    var stringified = v.toString();
    return stringified.length === 1 ? '0' + stringified : stringified;
}



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/CalendarComponent/GhContribCalendarComponent.ts
// module id = 17
// module chunks = 0 1